import React, { memo } from 'react';
import { FieldGroup } from '../../components';
import { baseSymbol } from '../../core/currency';

const defaultHighlight = {
  images: [],
  material: null,
  diameter: null,
  date: null,
  price: null,
};

export const Highlight = memo(function Highlight({
  idx,
  highlights,
  setHighlights,
  highlightErrors,
  setHighlightErrors,
}) {
  const highlight = highlights?.[idx] || defaultHighlight;
  const errors = highlightErrors?.[idx] || {};

  const onChange = (key, value) => {
    if (key === 'price' && value) {
      value = parseInt(value) * 100;
    }

    setHighlightErrors((prevErrors) => {
      const newErrors = { ...(prevErrors || {}) };
      newErrors[idx] = {
        ...errors,
        [key]: null,
      };

      return newErrors;
    });
    setHighlights((highlights) => {
      const newHighlights = [...(highlights || [])];
      newHighlights[idx] = {
        ...highlight,
        [key]: value,
      };

      return newHighlights;
    });
  }

  return (
    <div className="highlight">
      <div className="title">
        Highlight {idx + 1}
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <FieldGroup
            noFormik
            className={'mt-0'}
            placeholder=""
            name="images"
            type="galleryUpload"
            value={highlight.images}
            onChange={(value) => onChange('images', value)}
            rules={{ limit: 5 }}
          />
        </div>
      </div>
      <div className="error">
        {errors.images ? "5 images are required" : null}
      </div>

      <div className="row fields">
        <div className="col-12 col-md-6 col-lg-3">
          <FieldGroup
            name="material"
            type="text"
            persistLabel
            inputStyle={{ paddingLeft: '100px', width: '100%', border: errors.material ? '1px solid red' : null }}
            placeholder="Material:"
            value={highlight.material || ''}
            onChange={(e) => onChange('material', e.target.value)}
            noFormik
          />
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <FieldGroup
            name="diameter"
            type="text"
            persistLabel
            inputStyle={{ paddingLeft: '100px', width: "100%", border: errors.diameter ? "1px solid red" : null }}
            placeholder="Diameter:"
            value={highlight.diameter || ''}
            onChange={(e) => onChange('diameter', e.target.value)}
            noFormik
          />
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <FieldGroup
            name="date"
            type="text"
            persistLabel
            inputStyle={{ paddingLeft: '65px', width: '100%', border: errors.date ? '1px solid red' : null }}
            placeholder="Date:"
            value={highlight.date || ''}
            onChange={(e) => onChange('date', e.target.value)}
            noFormik
          />
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <FieldGroup
            name="price"
            type="numberFormat"
            persistLabel
            inputStyle={{ paddingLeft: '78px', width: '100%', border: errors.price ? '1px solid red' : null }}
            placeholder={`Price: ${baseSymbol()}`}
            value={highlight.price ? highlight.price / 100 : null}
            onChange={(value) => onChange('price', value)}
            noFormik
          />
        </div>
      </div>
    </div>
  );
});
